 
<div class="container text-center">
  <br/>
  <br/>
  <div class="col-lg-11">
    
    
  <div class="dx-fieldset">
   <div class="dx-fieldset-header" *ngIf="sendMessage"> <h3>{{messageResult}}</h3></div> 
   <!-- <div class="text-danger" *ngIf="errorMessage.length!= 0">Usuario o contraseña no valido</div> -->
  </div> 
  </div>
    <div class="col-lg-11" *ngIf="!sendMessage">
       <div class="col-md-6 offset-md-3">
           <form  (keydown.enter)="$event.preventDefault()" 
                  #theForm = "ngForm" action="your action" 
                  (submit)="onFormSubmit($event)">
               <div class="dx-fieldset">
                 <div class="dx-fieldset-header"> Recuperar contraseña</div> 
                 <div class="dx-field">
                   <div class="dx-field-label">Usuario</div>
                   <div class="dx-field-value">
                     <dx-text-box [(value)]="creds.username"  >
                       <dx-validator>
                         <dxi-validation-rule type="required" message="Usuario requerido"></dxi-validation-rule>
                       </dx-validator>
                     </dx-text-box>
                   </div>
                 </div> 
              
                 <div class="dx-fieldset">
                     <!-- <dx-validation-summary id="summary"></dx-validation-summary> (click)="onRecoveryPws()"--> 
                     <dx-button 
                         id="button"
                         text="Enviar"
                         type="success"  
                         
                         [useSubmitBehavior]="true"
                         [disabled]="theForm.invalid">
                     </dx-button>
                 </div>
             </div> 
           </form>
      </div>
     
    </div>
 </div> 
 
 
 
 
  